.SwitchLabel {
  place-self: auto;
  color: var(--black);

  :first-child {
    grid-column: 0;
  }

  :last-child {
    grid-column: 1;
    grid-row: 1;
  }

  &:has(:checked) [data-slot="text"] {
    color: var(--black);
  }
}

.Select [data-selected-id="NO_ID"] {
  color: var(--neutral-1);

  option {
    color: var(--black);
  }
}
